import Logger from './logger';


export type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface NotificationOptions {
  title?: string;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Notification helper
 * Provides a foundation for toast notifications
 * Can be extended with a toast library (e.g., Radix UI Toast)
 */
class NotificationService {
  private logger = new Logger({ tag: 'NOTIFICATIONS' });
  private listeners: Array<(message: string, type: NotificationType, options?: NotificationOptions) => void> = [];

  subscribe(listener: (message: string, type: NotificationType, options?: NotificationOptions) => void) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  private notify(message: string, type: NotificationType, options?: NotificationOptions) {
    this.logger.info(`Notification [${type}]: ${message}`, options);
    this.listeners.forEach((listener) => listener(message, type, options));
  }

  success(message: string, options?: NotificationOptions) {
    this.notify(message, 'success', options);
  }

  error(message: string, options?: NotificationOptions) {
    this.notify(message, 'error', options);
  }

  info(message: string, options?: NotificationOptions) {
    this.notify(message, 'info', options);
  }

  warning(message: string, options?: NotificationOptions) {
    this.notify(message, 'warning', options);
  }
}

export const notifications = new NotificationService();

